export default __webpack_public_path__ + "static/media/in-progress.6ea9b4eb.svg";